<template>
  <section class="settings">
    <heading>Settings</heading>
    <FormulateInput
      v-model="settingsObj.darkMode"
      type="checkbox"
      @input="updateSettings"
      label="Dark Mode"
    />

    <p>
      This app was designed and created by
      <a href="dominiktampe.de" target="_blank">Dominik Tampe</a> for a class at
      University of Applied Sciences Munich. You can find the source code here:
      <a href="https://gitlab.com/hm-webdesign/plnr" _target="_blank"
        >https://gitlab.com/hm-webdesign/plnr</a
      >
    </p>
  </section>
</template>

<script>
import Heading from "@/components/Heading"

export default {
  name: "Settings",
  components: {
    Heading
  },
  computed: {
    settings() {
      return this.$store.state.settings
    }
  },
  created() {
    this.settingsObj = this.settings
  },
  data() {
    return {
      settingsObj: {}
    }
  },
  methods: {
    updateSettings() {
      this.$store.commit("updateSettings", this.settingsObj)
    }
  }
}
</script>

<style lang="scss">
.settings {
  p {
    font-size: 0.75rem;
    text-align: center;
    @include themed() {
      color: t($text-secondary);
    }
  }
  a {
    @include themed() {
      color: t($primary);
    }
  }
}
</style>
